import { React, useEffect, useState } from "react";
import {
  HaberForm,
  RightDrawerContainer,
  DownArrowDraw,
  DetailFields,
  ProductionSet,
} from "../../../../../src/Pages/styledElements";
import {
  Button,
  Form,
  Input,
  Select,
  Col,
  Row,
  Checkbox,
  Tooltip,
  DatePicker,
} from "antd";
import Iconmoon from "../../../../Components/IconsFiles/icon";
import RightDrawerSidebar from "../../../../Components/RightDrawer/rightDrawer";
import { DatePickerY } from "../../../../../src/Pages/pageStyled";
import moment from "moment";
import { getParentReelDetailsById } from "../../../../Services/productionPlanningServices";
import {
  lengthUnit,
  weightUnit,
} from "../../../../Utils/Constant/MeasurementUnitList";

const { Option } = Select;
const capitalize = (item) => item?.charAt(0)?.toUpperCase() + item?.slice(1);
const showProductionStatus = (status) => {
  return capitalize(
    status === "open"
      ? "Not Mapped"
      : status === "cancel"
      ? "Cancelled"
      : status
  );
};
const ParentReelDrawer = (props) => {
  const [form] = Form.useForm();

  const orderTypeData = ["Sheet", "Reel"];
  const [details, setDetails] = useState();
  const hcDate = {
    dateOfBirth: moment("2020-06-09T12:40:14+0000"),
  };
  const [validateData, setValidateData] = useState({
    type: "",
    price: "",
    weight: "",
  });
  const deckleWidthUnitData = ["mm", "cm"];
  const handleType = (e) => {
    setValidateData({ ...validateData, type: e });
  };

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  useEffect(() => {
    if (props.id) {
      setDetails();
      getParentReelDetailsById(props.id)
        .then((resp) => {
          setDetails(resp.data.data);
        })
        .catch((err) => console.log(err));
    }
  }, [props]);

  return details ? (
    <RightDrawerSidebar
      title={
        details.machine_type === "cutter"
          ? `Parent Set - ${details.id}`
          : `Parent Reel - ${details.id}`
      }
      // subtitle={`Weight: ${details.weight?.toFixed(3)}${" "}${(details?.units && details.units.weight) ? capitalize(weightUnit[details.units.weight]?.displayName) : "T"}`}
      visible={props.visible}
      onClose={() => {
        props.onCloseParentReelDrawer();
      }}
    >
      <RightDrawerContainer>
        <div className="resetPassForm removePadLeft">
          <DetailFields className="marginBtnP">
            <HaberForm>
              <Form
                name="basic"
                autoComplete="off"
                className="haberLogin haberSignup"
                style={{ marginTop: "0" }}
              >
                <div
                  className="drawerField"
                  style={{ paddingTop: "5px", paddingBottom: "10px" }}
                >
                  <div className="titleWithText">
                    <h5 style={{ paddingBottom: "13px" }}>General Details</h5>
                    {details?.machine_type !== "cutter" && (
                      <p style={{ marginTop: "-10px" }}>
                        Reel / Core Diameter: {details.reel_od}{' '}
                        {details?.units && details?.units?.reel_od
                          ? lengthUnit[
                              details.units.reel_od
                            ]?.displayName.toUpperCase()
                          : ""}
                        {" / "}
                        {details.core_id}{' '}
                        {details?.units && details?.units?.core_id
                          ? lengthUnit[
                              details.units.core_id
                            ]?.displayName.toUpperCase()
                          : ""}
                      </p>
                    )}
                    <p style={{ marginTop: "-10px" }}>
                      Weight: {details.weight?.toFixed(3)}{' '}
                      {details?.units && details?.units?.parent_roll_weight
                        ? capitalize(
                            weightUnit[details.units.parent_roll_weight]
                              ?.displayName
                          )
                        : "T"}
                    </p>
                    <p style={{ marginTop: "-10px" }}>Mapped Jumbo:</p>
                    {/* <br /> */}
                    {details.mapped_jumbo_reels_info.map((item) => (
                      <p style={{ marginTop: "-10px" }}>
                        {`${item.number} (${item.weight_utilized} ${" "} ${
                          item?.units && item?.units?.weight_utilized
                            ? capitalize(
                                weightUnit[item.units.weight_utilized]
                                  ?.displayName
                              )
                            : "T"
                        })`}
                      </p>
                    ))}
                  </div>
                </div>
                {((details.jumbo_reels?.length !== 0 &&
                  details?.machine_type !== "cutter") ||
                  (details.jumbo_reels?.length !== 0 &&
                    details?.machine_type === "cutter" &&
                    (details.status === "mapped" ||
                      details.status === "produced" ||
                      details.status === "rejected"))) && (
                  <div
                    className="drawerField"
                    style={{ paddingBottom: "15px" }}
                  >
                    <div className="titleWithText titlebytwo">
                      <h5>Jumbo Reels</h5>
                      {details.mapped_jumbo_reels_info.map((item) => (
                        <p>
                          {`${item.number} (${item.weight_utilized} ${" "} ${
                            item?.units && item.units.weight_utilized
                              ? capitalize(
                                  weightUnit[item.units.weight_utilized]
                                    ?.displayName
                                )
                              : "T"
                          })`}
                        </p>
                      ))}
                    </div>
                  </div>
                )}
                {details.status === "mapped" && (
                  <div className="drawerField">
                    <div className="titleWithText">
                      <h5>Mapping Date</h5>
                      {details?.machine_type !== "cutter" ? (
                        <p>The reel was mapped on selected date</p>
                      ) : (
                        <p>The sheets were mapped on selected date</p>
                      )}
                    </div>
                    <DatePickerY>
                      <Form.Item
                        name="mappingDate"
                        initialValue={
                          details.mapped_date
                            ? moment(details.mapped_date, "YYYY-MM-DD")
                            : null
                        }
                      >
                        <DatePicker format={"DD-MM-YYYY"} disabled />
                      </Form.Item>
                    </DatePickerY>
                  </div>
                )}
                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Mapping Date</h5>
                    {details?.machine_type !== "cutter" ? (
                      <p>The reel was mapped on selected date</p>
                    ) : (
                      <p>The sheets were mapped on selected date</p>
                    )}
                  </div>
                  <div className="boxFormType">
                    <DatePickerY>
                      <Form.Item
                        name="completionDate"
                        initialValue={
                          details.mapped_date
                            ? moment(details.mapped_date, "YYYY-MM-DD")
                            : null
                        }
                      >
                        <DatePicker format={"DD-MM-YYYY"} disabled />
                      </Form.Item>
                    </DatePickerY>
                  </div>
                </div>
                {(details.status === "mapped" ||
                  details.status === "produced") && (
                  <>
                    {(details.rewinding_date || details.rewinding_shift) &&
                    details?.machine_type !== "cutter" ? (
                      <div className="drawerField removeStar">
                        <div className="titleWithText">
                          <h5>Rewinding Date and Shift</h5>
                          <p>The reel will be rewinded on selected date</p>
                        </div>
                        <Row className="centerAlign justifyCSBetween">
                          <Col span={details.rewinding_shift ? 11 : 24}>
                            <div
                              className="boxFormType"
                              style={{ marginBottom: "0" }}
                            >
                              <DatePickerY>
                                <Form.Item
                                  // label="Date"
                                  name="rewindingDate"
                                  className="dBlock"
                                  initialValue={
                                    details.rewinding_date
                                      ? moment(details.rewinding_date)
                                      : null
                                  }
                                  style={{ marginBottom: "0px" }}
                                >
                                  <DatePicker format={"DD-MM-YYYY"} disabled />
                                </Form.Item>{" "}
                                <p>Date</p>
                              </DatePickerY>
                            </div>
                          </Col>
                          <Col span={details.rewinding_date ? 11 : 24}>
                            <div className="boxFormType">
                              <Form.Item
                                // label="Shift"
                                name="Shift"
                                rules={[{ required: true }]}
                                className="dBlock"
                                initialValue={details.rewinding_shift}
                                style={{ marginBottom: "0px" }}
                              >
                                <Input placeholder="Text" disabled />
                              </Form.Item>{" "}
                              <p>Shift</p>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    ) : (
                      (details.cutting_date || details.cutting_shift) &&
                      details?.machine_type === "cutter" && (
                        <div className="drawerField removeStar">
                          <div className="titleWithText">
                            <h5>Cutting Date and Shift</h5>
                            <p>The sheet were cut on selected date</p>
                          </div>
                          <Row className="centerAlign justifyCSBetween">
                            <Col span={details.cutting_shift ? 11 : 24}>
                              <div
                                className="boxFormType"
                                style={{ marginBottom: "0" }}
                              >
                                <DatePickerY>
                                  <Form.Item
                                    label="Date"
                                    name="rewindingDate"
                                    className="dBlock"
                                    initialValue={
                                      details.cutting_date
                                        ? moment(details.cutting_date)
                                        : null
                                    }
                                  >
                                    <DatePicker
                                      format={"DD-MM-YYYY"}
                                      disabled
                                    />
                                  </Form.Item>
                                </DatePickerY>
                              </div>
                            </Col>
                            <Col span={details.cutting_date ? 11 : 24}>
                              <div className="boxFormType">
                                <Form.Item
                                  label="Shift"
                                  name="Shift"
                                  rules={[{ required: true }]}
                                  className="dBlock"
                                  initialValue={details.cutting_shift}
                                >
                                  <Input placeholder="Text" disabled />
                                </Form.Item>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      )
                    )}
                    {details.status === "produced" &&
                    details?.machine_type !== "cutter" ? (
                      <div className="drawerField">
                        <div className="titleWithText">
                          <h5>Production Completion Date</h5>
                          <p>The reel was be rewinded on selected date</p>
                        </div>
                        <div className="boxFormType">
                          <DatePickerY>
                            <Form.Item
                              name="completionDate"
                              initialValue={
                                details.production_date
                                  ? moment(
                                      details.production_date,
                                      "YYYY-MM-DD"
                                    )
                                  : null
                              }
                            >
                              <DatePicker format={"DD-MM-YYYY"} disabled />
                            </Form.Item>
                          </DatePickerY>
                        </div>
                      </div>
                    ) : (
                      details.status === "produced" &&
                      details?.machine_type === "cutter" && (
                        <div className="drawerField">
                          <div className="titleWithText">
                            <h5>Production Completed Date</h5>
                            <p>
                              The conversion for the sheet was complete on
                              selected date
                            </p>
                          </div>
                          <div className="boxFormType">
                            <DatePickerY>
                              <Form.Item
                                name="completionDate"
                                initialValue={
                                  details.production_date
                                    ? moment(
                                        details.production_date,
                                        "YYYY-MM-DD"
                                      )
                                    : null
                                }
                              >
                                <DatePicker format={"DD-MM-YYYY"} disabled />
                              </Form.Item>
                            </DatePickerY>
                          </div>
                        </div>
                      )
                    )}
                  </>
                )}
                {details?.machine_type !== "cutter" ? (
                  <div className="drawerField">
                    <div className="titleWithText">
                      <h5>Reels</h5>
                      <p>
                        All the child reels of this parent reel can be viewed
                        here
                      </p>
                    </div>
                    <div className="prod-reelset">
                      {details.reels?.map((reel) => (
                        <ProductionSet>
                          <div className="prodset-header">
                            <Iconmoon
                              icon="tissue-role"
                              size={28}
                              color="#EA655B"
                            />
                            <div className="prodleft-header">
                              <h4>
                                {reel.id}
                                {reel.forced && (
                                  <span dataset="Priority">Priority</span>
                                )}
                                {reel.intermediate_reels && (
                                  <span
                                    style={{
                                      color: "#6a6866",
                                      backgroundColor: "#edebe9",
                                      marginTop: "auto",
                                    }}
                                  >
                                    Intermediate
                                  </span>
                                )}
                              </h4>
                              {reel.reel_type == "order" && (
                                <label>
                                  Delivery Date:{" "}
                                  {moment(reel.delivery_date).format(
                                    "DD-MM-YYYY"
                                  )}
                                </label>
                              )}
                            </div>
                          </div>
                          <div className="prodset-body">
                            <div className="d-flex prodset-sb">
                              <div className="prodset-dt prod-50">
                                <h5>Reel Weight:</h5>
                                <p>
                                  {reel.weight}{" "}
                                  {reel.units && reel?.units?.weight
                                    ? capitalize(
                                        weightUnit[reel.units.weight]
                                          ?.displayName
                                      )
                                    : "T"}
                                </p>
                              </div>
                              <div className="prodset-dt prod-50">
                                <h5>Reel Size:</h5>
                                <p>
                                  {reel.reel_size}{" "}
                                  {reel?.units && reel?.units?.reel_size
                                    ? lengthUnit[
                                        reel.units.reel_size
                                      ]?.displayName?.toUpperCase()
                                    : "CM"}
                                </p>
                                {/* <p>{reel.reel_size} {(reel?.units && reel?.units?.size)? lengthUnit[reel.units.size]?.displayName?.toUpperCase() : "CM"}</p> */}
                              </div>
                            </div>
                            <div className="d-flex prodset-sb">
                              <div className="prodset-dt prod-50">
                                <h5>Length:</h5>
                                {reel.reel_length}{" "}
                                {reel?.units && reel?.units?.reel_length
                                  ? lengthUnit[
                                      reel.units.reel_length
                                    ]?.displayName?.toUpperCase()
                                  : "CM"}
                                {/* <p>{reel.weight} {(reel.units && reel?.units?.weight)? capitalize(weightUnit[reel.units.weight]?.displayName) : "T"}</p> */}
                              </div>
                              <div className="prodset-dt prod-50">
                                {reel.reel_type == "order" ? (
                                  <h5>Order Size:</h5>
                                ) : (
                                  <h5>Stock Size:</h5>
                                )}
                                {reel.reel_type == "order" ? (
                                  !reel.intermediate_reels ? (
                                    <p>
                                      {reel.size}{" "}
                                      {reel?.units && reel?.units?.size
                                        ? lengthUnit[
                                            reel.units.size
                                          ]?.displayName?.toUpperCase()
                                        : "CM"}
                                    </p>
                                  ) : (
                                    <p>
                                      {reel.width}{" "}
                                      {reel?.units && reel?.units?.width
                                        ? lengthUnit[
                                            reel.units.width
                                          ]?.displayName?.toUpperCase()
                                        : "CM"}
                                      {" x "}
                                      {reel.length}{" "}
                                      {reel?.units && reel?.units?.length
                                        ? lengthUnit[
                                            reel.units.length
                                          ]?.displayName?.toUpperCase()
                                        : "CM"}
                                    </p>
                                  )
                                ) : (
                                  (reel.width>0 && reel.length>0) ? (
                                    
                                    <p>
                                      {reel.width}{" "}
                                      {reel?.units && reel?.units?.width
                                        ? lengthUnit[
                                            reel.units.width
                                          ]?.displayName?.toUpperCase()
                                        : "CM"}
                                      {" x "}
                                      {reel.length}{" "}
                                      {reel?.units && reel?.units?.length
                                        ? lengthUnit[
                                            reel.units.length
                                          ]?.displayName?.toUpperCase()
                                        : "CM"}
                                    </p>
                                    ) : (
                                      <p>
                                      {reel.size}{" "}
                                      {reel?.units && reel?.units?.size
                                        ? lengthUnit[
                                            reel.units.size
                                          ]?.displayName?.toUpperCase()
                                        : "CM"}
                                    </p>
                                  )
                                )}
                                {/* {reel.reel_type == "order" ? (
                                  <p>
                                    {reel.size}{" "}
                                    {reel?.units && reel?.units?.size
                                      ? lengthUnit[
                                          reel.units.size
                                        ]?.displayName?.toUpperCase()
                                      : "CM"}
                                  </p>
                                ) : (
                                  <p></p>
                                )} */}
                              </div>
                            </div>
                            {reel.reel_type == "order" ? (
                              <div>
                                <div className="prodset-dt">
                                  <h5>PO NO.:</h5>
                                  {reel?.po?.length > 11 ? (
                                        <Tooltip placement="bottomLeft" title={reel?.po}>
                                          <p>{reel?.po?.slice(0,12)+"..."}</p>
                                        </Tooltip>) : (
                                          <p>{reel?.po}</p>
                                  )}
                                </div>
                                <div className="prodset-dt">
                                  <h5>ORDER NO.:</h5>
                                  <p>{reel.order}</p>
                                </div>
                              </div>
                            ) : (
                              <div className="prodset-dt">
                                <h5>STOCK NO.:</h5>
                                <p>{`${reel.stock}`}</p>
                              </div>
                            )}
                            {/* <div className="d-flex prodset-sb">
                              <div className="prodset-dt prod-50">
                                <h5>Weight:</h5>
                                <p>{reel.weight} {" "} {(reel?.units && reel?.units?.weight) ?  capitalize(weightUnit[reel.units.weight]?.displayName) : "T"}</p>
                              </div>
                              <div className="prodset-dt prod-50">
                                <h5>Size:</h5>
                                <p>{reel.size} {" "} {(reel?.units && reel?.units?.size) ?  lengthUnit[reel.units.size]?.displayName?.toUpperCase() : "CM"}</p>
                              </div>
                            </div> */}
                          </div>
                          <div className="prodset-footer">
                            <label>Production Status</label>
                            <span dataset={showProductionStatus(reel.status)}>
                              {showProductionStatus(reel.status)}
                            </span>
                          </div>
                        </ProductionSet>
                      ))}
                    </div>
                  </div>
                ) : (
                  <div className="drawerField">
                    <div className="titleWithText">
                      <h5>Sheets</h5>
                      <p>
                        All the child sheets of this parent set can be viewed
                        here
                      </p>
                    </div>
                    <div className="prod-reelset">
                      {details.reels?.map((sheet) => (
                        <ProductionSet>
                          <div className="prodset-header">
                            <Iconmoon icon="sheet" size={28} color="#EA655B" />
                            <div className="prodleft-header">
                              <h4>
                                {sheet.id}
                                {sheet.forced && (
                                  <span dataset="Priority">Priority</span>
                                )}
                              </h4>
                              {sheet.reel_type == "order" && (
                                <label>
                                  Delivery Date:{" "}
                                  {moment(sheet.delivery_date).format(
                                    "DD-MM-YYYY"
                                  )}
                                </label>
                              )}
                            </div>
                          </div>
                          <div className="prodset-body">
                            {sheet.reel_type == "order" ? (
                              <div>
                                <div className="prodset-dt">
                                  <h5>PO NO.:</h5>
                                  {sheet?.po?.length > 11 ? (
                                        <Tooltip placement="bottomLeft" title={sheet?.po}>
                                          <p>{sheet?.po?.slice(0,12)+"..."}</p>
                                        </Tooltip>) : (
                                          <p>{sheet?.po}</p>
                                        )}
                                </div>
                                <div className="prodset-dt">
                                  <h5>ORDER NO.:</h5>
                                  <p>{sheet.order}</p>
                                </div>
                              </div>
                            ) : (
                              <div className="prodset-dt">
                                <h5>STOCK NO.:</h5>
                                <p>{`${sheet.stock}`}</p>
                              </div>
                            )}
                            <div className="d-flex prodset-sb">
                              <div className="prodset-dt prod-50">
                                <h5>Size:</h5>
                                <p>
                                  {sheet.length}
                                  {sheet.length && sheet.width ? " x " : ""}
                                  {sheet.width}{" "}
                                  {sheet.length &&
                                  sheet.width &&
                                  sheet.units &&
                                  sheet.units.size
                                    ? lengthUnit[
                                        sheet.units.size
                                      ]?.displayName?.toUpperCase()
                                    : "CM"}
                                </p>
                              </div>
                              <div className="prodset-dt prod-50">
                                <h5>Grain:</h5>
                                <p>{`${
                                  sheet.grain ? capitalize(sheet.grain) : ""
                                }`}</p>
                              </div>
                            </div>
                            <div className="d-flex prodset-sb">
                              <div className="prodset-dt prod-50">
                                <h5>Weight:</h5>
                                <p>
                                  {sheet.weight}{" "}
                                  {sheet?.units && sheet?.units?.weight
                                    ? capitalize(
                                        weightUnit[sheet.units.weight]
                                          ?.displayName
                                      )
                                    : "T"}
                                </p>
                              </div>
                              <div className="prodset-dt prod-50">
                                <h5>Sheets:</h5>
                                <p>{sheet.no_of_sheets}</p>
                              </div>
                            </div>
                            <div className="prodset-body">
                              <div className="prodset-dt">
                                <h5>Produced Sheets:</h5>
                                <p>{`${
                                  sheet.accepted_no_of_sheets
                                } (${sheet.accepted_weight.toFixed(
                                  3
                                )}) ${" "} ${
                                  sheet?.units && sheet?.units?.weight
                                    ? capitalize(
                                        weightUnit[sheet.units.weight]
                                          ?.displayName
                                      )
                                    : "T"
                                }`}</p>
                              </div>
                            </div>
                            <div className="prodset-body">
                              <div className="prodset-dt">
                                <h5>Rejected Sheets:</h5>
                                <p>{`${
                                  sheet.rejected_no_of_sheets
                                } (${sheet.rejected_weight.toFixed(
                                  3
                                )}) ${" "} ${
                                  sheet?.units && sheet?.units?.weight
                                    ? capitalize(
                                        weightUnit[sheet.units.weight]
                                          ?.displayName
                                      )
                                    : "T"
                                }`}</p>
                              </div>
                            </div>
                          </div>
                          <div className="prodset-footer">
                            <label>Production Status</label>
                            <span dataset={showProductionStatus(sheet.status)}>
                              {showProductionStatus(sheet.status)}
                            </span>
                          </div>
                        </ProductionSet>
                      ))}
                    </div>
                  </div>
                )}
              </Form>
            </HaberForm>
          </DetailFields>
        </div>
      </RightDrawerContainer>
    </RightDrawerSidebar>
  ) : (
    <></>
  );
};

export default ParentReelDrawer;
